import { render, staticRenderFns } from "./Guest.vue?vue&type=template&id=bec2ba8c&scoped=true&"
import script from "./Guest.vue?vue&type=script&lang=js&"
export * from "./Guest.vue?vue&type=script&lang=js&"
import style0 from "./Guest.vue?vue&type=style&index=0&id=bec2ba8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec2ba8c",
  null
  
)

export default component.exports